import BusRatesTable from './BusRatesTable';
import './smallkey.css';
import { Helmet } from 'react-helmet';
import FaqSection from './FAQKeyword';
import FleetHighway from './FleetHighway';
import ContactShowcase from './phoneToWhatsApp';
import TestimonialSectionKeyword from './TestimonialSectionKeyword';

function Taxiserviceatmumbaiinternationalairport() {



    const cardData = {




keyword: "Taxi Service at Mumbai International Airport",

headingDescription: "Shreesha Tours & Travels offers reliable, safe, and affordable Taxi Service at Mumbai International Airport with 24/7 pickup and drop facilities from Chhatrapati Shivaji Maharaj International Airport (Terminal 1 & Terminal 2). We provide airport transfers, one-way cabs, round-trip taxi services, corporate transportation, hotel transfers, business travel, family vacations, and outstation cab services to major cities across Maharashtra and India. Our fleet includes Sedan, Swift Dzire, Ertiga, SUV, Innova, Innova Crysta, Tempo Traveller, Urbania, Mini Bus, and luxury vehicles driven by experienced chauffeurs who ensure timely pickups by monitoring flight schedules. With doorstep drop, transparent pricing, easy online booking, professional drivers, and 24/7 customer support, Shreesha Tours & Travels guarantees a smooth, comfortable, and hassle-free airport travel experience. Whether you are arriving for business, tourism, family functions, medical visits, or holidays, our Mumbai International Airport taxi service provides dependable transportation to your destination with complete comfort and convenience.",

topPlaces: [
  {
    title: "Mumbai Airport to Pune",
    description: "Pune is the most frequently booked destination from Mumbai International Airport. Business executives, IT professionals, students, and families prefer direct airport cabs to Hinjawadi, Baner, Kharadi, Magarpatta, Wakad, Pimpri-Chinchwad, and other parts of Pune."
  },
  {
    title: "Mumbai Airport to Lonavala",
    description: "Lonavala is a popular hill station famous for Tiger Point, Bhushi Dam, Karla Caves, waterfalls, and scenic valleys. Airport taxi services provide a comfortable and direct journey for tourists and weekend travelers."
  },
  {
    title: "Mumbai Airport to Mahabaleshwar",
    description: "Mahabaleshwar is one of Maharashtra's most beautiful hill stations, known for Venna Lake, Arthur's Seat, strawberry farms, and breathtaking viewpoints. Travelers arriving at Mumbai Airport often book direct cabs for a relaxing holiday."
  },
  {
    title: "Mumbai Airport to Shirdi",
    description: "Shirdi is one of India's most visited pilgrimage destinations, attracting devotees throughout the year. Direct airport taxi services provide comfortable transportation to the famous Shri Sai Baba Samadhi Mandir."
  },
  {
    title: "Mumbai Airport to Nashik",
    description: "Nashik is renowned for Trimbakeshwar Jyotirlinga, Panchavati, vineyards, and industrial hubs. Airport cab services are widely booked for religious tours, business travel, and family visits."
  },
  {
    title: "Mumbai Airport to Goa",
    description: "Goa is a favorite holiday destination offering beautiful beaches, luxury resorts, Portuguese churches, forts, casinos, and water sports. Long-distance airport cabs provide a convenient road travel option."
  },
  {
    title: "Mumbai Airport to Surat",
    description: "Surat is a leading commercial city known for its diamond and textile industries. Corporate travelers frequently book airport taxis for business meetings, industrial visits, and executive travel."
  },
  {
    title: "Mumbai Airport to Ahmedabad",
    description: "Ahmedabad is Gujarat's commercial capital with major industries, corporate offices, and heritage attractions. Direct airport cab services provide comfortable transportation for business and leisure travelers."
  },
  {
    title: "Mumbai Airport to Indore",
    description: "Indore is Madhya Pradesh's commercial hub, famous for Rajwada Palace, Sarafa Food Market, and nearby Ujjain and Omkareshwar. Airport taxis are commonly booked for business, family, and religious travel."
  },
  {
    title: "Mumbai Airport to Bangalore",
    description: "Bangalore is India's leading IT and startup hub with multinational companies, technology parks, and educational institutions. Long-distance airport cab services are preferred by corporate travelers and professionals."
  }
],



"services": [
  {
    "name": "Taxi Service at Mumbai International Airport",
    "description": "Book Taxi Service at Mumbai International Airport for safe, comfortable, and reliable airport transportation with professional chauffeurs and well-maintained AC vehicles. Choose from Sedan, Ertiga, Innova Crysta, SUV, Kia Carens, and Tempo Traveller options for airport pickups, hotel transfers, business travel, family trips, and outstation journeys. Enjoy flight tracking, doorstep pickup, luggage assistance, transparent pricing, and 24x7 customer support."
  },
  {
    "name": "Mumbai Airport Taxi Service",
    "description": "Choose Mumbai Airport Taxi Service for hassle-free airport pickup and drop with experienced drivers and clean, comfortable vehicles. Whether you are arriving or departing from Mumbai Airport, enjoy punctual service, affordable fares, easy online booking, and reliable transportation for local, corporate, family, and outstation travel."
  },
  {
    "name": "Mumbai Airport Cab Booking",
    "description": "Complete Mumbai Airport Cab Booking online with instant confirmation, flexible scheduling, and multiple vehicle options to suit every travel requirement. Book Sedan, Ertiga, Innova Crysta, SUV, and premium cabs for airport transfers, business meetings, hotel pickups, railway station transfers, and long-distance travel with professional chauffeur service."
  },
  {
    "name": "Mumbai International Airport Cab",
    "description": "Hire Mumbai International Airport Cab for comfortable and dependable transportation to and from Chhatrapati Shivaji Maharaj International Airport. Enjoy professional drivers, spacious luggage capacity, AC vehicles, timely pickups, flight monitoring, and customized travel solutions for individuals, families, tourists, and corporate travelers."
  },
  {
    "name": "Airport Transfer Mumbai",
    "description": "Book Airport Transfer Mumbai for seamless airport transportation with punctual chauffeurs and comfortable AC vehicles. Our airport transfer service is perfect for domestic and international travelers requiring hotel transfers, office transfers, local city travel, or outstation destinations with affordable pricing and 24x7 availability."
  },
  {
    "name": "Mumbai Airport Pickup Taxi",
    "description": "Reserve Mumbai Airport Pickup Taxi for timely airport arrivals with professional drivers waiting at the airport for a smooth pickup experience. Benefit from flight tracking, luggage assistance, comfortable vehicles, fixed pricing, and reliable transportation to hotels, homes, offices, or outstation destinations."
  },
  {
    "name": "Mumbai Airport Drop Cab",
    "description": "Book Mumbai Airport Drop Cab for timely departures with reliable chauffeur-driven vehicles and comfortable travel from any location in Mumbai or nearby cities. Our airport drop service ensures punctual arrivals, stress-free travel, clean AC vehicles, and professional customer support for every journey."
  },
  {
    "name": "T2 Airport Mumbai Taxi Service",
    "description": "Choose T2 Airport Mumbai Taxi Service for reliable transportation to and from Terminal 2 with experienced chauffeurs and premium AC vehicles. Enjoy quick pickups, convenient drop-offs, transparent fares, and comfortable travel for business executives, tourists, families, and corporate clients throughout Mumbai and beyond."
  },
  {
    "name": "Mumbai Airport Car Rental",
    "description": "Hire Mumbai Airport Car Rental for chauffeur-driven vehicles with flexible hourly, daily, and outstation rental packages. Choose from Sedan, Ertiga, Innova Crysta, SUV, Kia Carens, Tempo Traveller, and luxury vehicles for airport transfers, sightseeing, business travel, weddings, and family vacations."
  },
  {
    "name": "Mumbai Airport Outstation Cab",
    "description": "Book Mumbai Airport Outstation Cab for direct travel from the airport to destinations across Maharashtra, Goa, Gujarat, Karnataka, and other states. Enjoy one way and round trip cab services with experienced drivers, comfortable vehicles, transparent pricing, and convenient airport pickup facilities."
  },
  {
    "name": "Mumbai Airport Prepaid Taxi",
    "description": "Choose Mumbai Airport Prepaid Taxi for secure and transparent airport transportation with fixed fares and reliable chauffeur services. Travel comfortably in clean AC vehicles with no hidden charges, professional drivers, and easy booking for local city rides, hotels, railway stations, and outstation travel."
  },
  {
    "name": "Mumbai Airport Corporate Cab Service",
    "description": "Book Mumbai Airport Corporate Cab Service for executive airport transfers, business travel, client pickups, employee transportation, and VIP travel requirements. Our premium fleet, experienced chauffeurs, punctual service, monthly corporate billing, and 24x7 availability provide dependable airport transportation solutions for companies and professionals."
  }
],
"tableData": [
  ["Taxi Service at Mumbai International Airport", "Mumbai Airport Taxi Service"],
  ["Mumbai Airport Cab Booking", "Mumbai International Airport Cab"],
  ["Airport Transfer Mumbai", "Mumbai Airport Pickup Taxi"],
  ["Mumbai Airport Drop Cab", "T2 Airport Mumbai Taxi Service"],
  ["Mumbai Airport Car Rental", "Mumbai Airport Outstation Cab"],
  ["Mumbai Airport Prepaid Taxi", "Mumbai Airport Corporate Cab Service"]
],




whychoose: [
  {
    WhyChooseheading: "Hassle-Free Taxi Service at Mumbai International Airport",
    WhyChoosedescription: "Begin or end your journey with confidence by choosing Shreesha Tours & Travels for taxi services at Mumbai International Airport. We provide reliable airport transfers for business travellers, tourists, families, NRIs, and international visitors with comfortable chauffeur-driven vehicles."
  },
  {
    WhyChooseheading: "Timely Airport Pickups with Flight Monitoring",
    WhyChoosedescription: "Our team schedules pickups according to your flight timing and helps minimize waiting, making airport arrivals and departures smooth and convenient regardless of the time of day."
  },
  {
    WhyChooseheading: "Comfortable Fleet for Every Passenger",
    WhyChoosedescription: "Choose from Hatchbacks, Swift Dzire, Sedan, Ertiga, Innova, Innova Crysta, SUVs, Luxury Cars, Tempo Travellers, and Mini Buses to suit individual travellers, families, business executives, and large groups."
  },
  {
    WhyChooseheading: "Direct Transfers to Popular Destinations",
    WhyChoosedescription: "Book airport taxis from Mumbai International Airport to Pune, Navi Mumbai, Thane, Lonavala, Alibaug, Nashik, Shirdi, Surat, Ahmedabad, Goa, and numerous destinations across India."
  },
  {
    WhyChooseheading: "Ideal for Corporate, Hotel & Home Transfers",
    WhyChoosedescription: "Our airport taxi service is suitable for hotel transfers, corporate pickups, office travel, conference guests, VIP transportation, residential pickups, and customized travel requirements."
  },
  {
    WhyChooseheading: "Professional Chauffeurs for Stress-Free Travel",
    WhyChoosedescription: "Experienced drivers ensure courteous service, safe driving, efficient route planning, and comfortable transportation from the airport to your destination."
  },
  {
    WhyChooseheading: "Flexible Airport Travel Options",
    WhyChoosedescription: "Choose one-way airport transfers, return airport journeys, multi-city travel, hourly rentals, or customized itineraries according to your travel schedule."
  },
  {
    WhyChooseheading: "Dependable Airport Transfers with Shreesha Tours & Travels",
    WhyChoosedescription: "With transparent pricing, responsive customer support, and well-maintained vehicles, we deliver a premium airport taxi experience for every passenger."
  }
]

};

const faqData = [
  {
    question: "Do you provide taxi service from Mumbai International Airport to other cities?",
    answer: "Yes, we offer airport taxi services from Mumbai International Airport to destinations across Maharashtra, Goa, Gujarat, Karnataka, Madhya Pradesh, Rajasthan, and many other states."
  },
  {
    question: "Can I pre-book an airport taxi before my flight lands?",
    answer: "Yes, advance bookings are recommended so your driver can be scheduled according to your flight arrival time."
  },
  {
    question: "Which vehicles are available for airport transfers?",
    answer: "We provide Hatchbacks, Swift Dzire, Sedan, Ertiga, Innova, Innova Crysta, SUVs, Luxury Cars, Tempo Travellers, and Mini Buses."
  },
  {
    question: "Do you offer airport pickup for international travellers and NRIs?",
    answer: "Yes, our airport transfer service is suitable for international passengers, overseas visitors, business delegates, and tourists arriving at Mumbai International Airport."
  },
  {
    question: "Can I book an airport taxi for a corporate executive?",
    answer: "Yes, we regularly provide executive airport transfers for companies, business professionals, conference attendees, and VIP guests."
  },
  {
    question: "Is luggage accommodated in your airport taxis?",
    answer: "Yes, we recommend vehicles based on the number of passengers and luggage to ensure a comfortable transfer."
  },
  {
    question: "Can I book an airport taxi with multiple drop locations?",
    answer: "Yes, customized routes with multiple drop-off points can be arranged depending on your travel requirements."
  },
  {
    question: "Are late-night and early-morning airport pickups available?",
    answer: "Yes, airport transfer services are available for scheduled flights throughout the day and night."
  },
  {
    question: "How is the airport taxi fare calculated?",
    answer: "The fare depends on the destination, vehicle category, travel distance, route, waiting requirements, and any additional stops requested."
  },
  {
    question: "How can I book a Taxi Service at Mumbai International Airport with Shreesha Tours & Travels?",
    answer: "Simply share your flight details, arrival or departure time, terminal, destination, passenger count, and preferred vehicle to receive a customized quotation and instant booking confirmation."
  }
];

const testimonials = [
  {
    id: 1,
    name: "Mr. Devansh Kapoor",
    feedback: "The airport transfer was managed with excellent coordination. Despite a delayed flight, the pickup was handled efficiently, making the onward journey completely stress-free.",
    rating: 5
  },
  {
    id: 2,
    name: "Mrs. Meera Nair",
    feedback: "Travelling after an international flight felt effortless thanks to the comfortable vehicle and professional chauffeur. The entire airport transfer experience was smooth from start to finish.",
    rating: 5
  }
];














    const Images = [
        { place: "/images/keyword/1.jpg", text: "Mumbai Outstation Cabs", link: "Mumbai-Outstation-Cabs" },
        { place: "/images/keyword/2.jpg", text: "Mumbai to Mahabaleshwar Cab", link: "Mumbai-to-Mahabaleshwar-Cab" },
        { place: "/images/keyword/3.jpg", text: "Mumbai to Goa Cabs", link: "Mumbai-to-Goa-Cabs" },
        { place: "/images/keyword/4.jpg", text: "Mumbai to Shirdi Cab", link: "Mumbai-to-Shirdi-Cab" },
        { place: "/images/keyword/5.jpg", text: "Mumbai to Nashik Cab", link: "Mumbai-to-Nashik-Cab" },
        { place: "/images/keyword/6.jpg", text: "Mumbai to Kolhapur Cab", link: "Mumbai-to-Kolhapur-Cab" },
        { place: "/images/keyword/7.jpg", text: "Mumbai to Pune Cab", link: "Mumbai-to-Pune-Cab" },
        { place: "/images/keyword/8.jpg", text: "Mumbai to Aurangabad Cab", link: "Mumbai-to-Aurangabad-Cab" },
        { place: "/images/keyword/9.jpg", text: "Mumbai to Bhimashankar Cab", link: "Mumbai-to-Bhimashankar-Cab" },
        { place: "/images/keyword/10.jpg", text: "Mumbai to Ashtavinayak Cab Service", link: "Mumbai-to-Ashtavinayak-Cab-Service" },
        { place: "/images/keyword/11.jpg", text: "Mumbai to 5 Jyotirlinga Cab", link: "Mumbai-to-5-Jyotirlinga-Cab" },
        { place: "/images/keyword/12.jpg", text: "Mumbai to Lonavala Cab", link: "Mumbai-to-Lonavala-Cab" },
        { place: "/images/keyword/13.jpg", text: "Mumbai to Konkan Darshan Cab Booking", link: "Mumbai-to-Konkan-Darshan-Cab-Booking" },
        { place: "/images/keyword/14.jpg", text: "Mumbai to Alibaug Cab", link: "Mumbai-to-Alibaug-Cab" },
        { place: "/images/keyword/15.jpg", text: "Mumbai to Ahmednagar Cab", link: "Mumbai-to-Ahmednagar-Cab" },
        { place: "/images/keyword/16.jpg", text: "Mumbai to Matheran Cab", link: "Mumbai-to-Matheran-Cab" },
        { place: "/images/keyword/17.jpg", text: "Mumbai to Jalgaon Cab Booking / Dhule", link: "Mumbai-to-Jalgaon-Cab-Booking-Dhule" },
        { place: "/images/keyword/18.jpg", text: "Mumbai to Lavasa Cab", link: "Mumbai-to-Lavasa-Cab" },
        { place: "/images/keyword/19.jpg", text: "Mumbai to Panchgani Cab", link: "Mumbai-to-Panchgani-Cab" },
        { place: "/images/keyword/20.jpg", text: "Mumbai to Khandala Taxi Fare", link: "Mumbai-to-Khandala-Taxi-Fare" },
        { place: "/images/keyword/21.jpg", text: "Mumbai to Surat Cab", link: "Mumbai-to-Surat-Cab" },
        { place: "/images/keyword/22.jpg", text: "Mumbai to Ahmedabad Cab", link: "Mumbai-to-Ahmedabad-Cab" },
        { place: "/images/keyword/23.jpg", text: "Mumbai to Narmada Parikrama Cab Booking", link: "Mumbai-to-Narmada-Parikrama-Cab-Booking" },
        { place: "/images/keyword/24.jpg", text: "Mumbai to Baroda Cabs", link: "Mumbai-to-Baroda-Cabs" },
        { place: "/images/keyword/25.jpg", text: "Mumbai to Daman Taxi", link: "Mumbai-to-Daman-Taxi" },
    ];









const productSchema = {
  "@context": "https://schema.org",
  "@type": "Product",
  "name": "Taxi Service at Mumbai International Airport",
  "image": "https://www.shreeshatravels.com/assets/images/taxi-service-at-mumbai-international-airport.webp",
  "description":
    "Book Taxi Service at Mumbai International Airport with Shreesha Tours & Travels for safe, comfortable, and affordable airport transfer services. We provide 24x7 airport pickup and drop taxi services from Mumbai International Airport with Sedan, Ertiga, SUV, Innova, and Innova Crysta for local travel, corporate transfers, hotel transfers, and outstation destinations.",
  "brand": {
    "@type": "Brand",
    "name": "Shreesha Tours & Travels"
  },
  "aggregateRating": {
    "@type": "AggregateRating",
    "bestRating": "5",
    "worstRating": "1",
    "ratingValue": "4.8",
    "ratingCount": "8517"
  },
  "offers": {
    "@type": "Offer",
    "priceCurrency": "INR",
    "price": "Starting From ₹12/Km",
    "availability": "https://schema.org/InStock",
    "url": "https://www.shreeshatravels.com/taxi-service-at-mumbai-international-airport"
  }
};




    return (
        <div>

<Helmet>
  <title>Taxi Service at Mumbai International Airport | 24x7 Airport Cabs | +91 8355835813</title>

  <meta
    name="description"
    content="Book Taxi Service at Mumbai International Airport with Shreesha Travels for reliable airport pickup and drop services. Hire Sedan, Ertiga, SUV, Innova, and Innova Crysta for local and outstation transfers with 24x7 online booking."
  />

  <meta
    name="keywords"
    content="Taxi Service at Mumbai International Airport, Mumbai Airport Taxi Service, Mumbai Airport Cab Booking, Mumbai International Airport Taxi, Mumbai Airport Cab Service, Airport Taxi Mumbai, Mumbai Airport Pickup Taxi, Mumbai Airport Drop Taxi, Mumbai Airport Transfer Service, Mumbai Airport Outstation Cab, Mumbai Airport Taxi Booking"
  />

  <script type="application/ld+json">
    {JSON.stringify(productSchema)}
  </script>
</Helmet>


            <section className="page-banner">
                <div className="page-banner-container">
                    <h2>
                        {cardData.keyword}
                    </h2>
                </div>
            </section>


















            <section>
                <div className="container-fluid p-0" >
                    <div className="row container-fluid px-md-2">
                        <div className="col-12 col-md-7 bg-foootr">
                            <img src='/images/keyword/46.jpg' alt='img' className='img-fluid' />
                            <h3 className="py-1"
                                style={{
                                    color: '#183765', // Red color for the title 
                                    textShadow: '5px 5px 10px rgba(255, 255, 255, 0.7)', // Light shadow effect
                                    fontWeight: 'bold'
                                }}


                            >Shreesha Tours & Travels: {cardData.keyword} </h3><p className='fw-bold '>{cardData.headingDescription}</p>

                            <div className="topPlaces">

                                <p className="sectionLead">Top Places to visit from {cardData.keyword} </p>
                                {cardData.topPlaces.map((place, index) => (
                                    <article key={index} className="placeCard borderr" tabIndex="0">
                                        <span className="placeBadge">{String(index + 1).padStart(2, "0")}</span>

                                        <div className="placeBody">
                                            <h4 className="placeTitle">{place.title}</h4>
                                            <p className="placeDesc">{place.description}</p>

                                        </div>

                                        <span className="placeArrow" aria-hidden>›</span>
                                    </article>
                                ))}
                            </div>





                            <div className="services-section">
                                {cardData.services.map((service, index) => (
                                    <div className="service-card" key={index}>
                                        <div className="service-content">
                                            <h4>{service.name}</h4>
                                            <span className="line"></span>
                                            <p>{service.description}</p>
                                        </div>

                                        <div className="service-icon">
                                            <i className="fas fa-arrow-right"></i>
                                        </div>
                                    </div>
                                ))}
                            </div>

                            <div className="keyword-grid">
                                {cardData.tableData.flat().map((keyword, index) => (
                                    <div key={index} className="keyword-item">
                                        <span className="keyword-bullet">-</span>
                                        {keyword}
                                    </div>
                                ))}
                            </div>



                            <div id="why-choose-section" className="why-choose-section">

                                <h2 className="section-title text-dark">
                                    Why Choose <span>Shreesha Tours & Travels</span>
                                </h2>

                                <div className="bento-grid">
                                    {cardData.whychoose.map((item, index) => (
                                        <div className="bento-card" key={index}>

                                            <div className="bento-number">
                                                {String(index + 1).padStart(2, "0")}
                                            </div>

                                            <h4>{item.WhyChooseheading}</h4>

                                            <p>{item.WhyChoosedescription}</p>

                                        </div>
                                    ))}
                                </div>

                            </div>



                            <div className="row twm-faq-section-1 m-b30">


                                <div className=" col-md-12 wow fadeInDown" data-wow-delay="0.2">
                                    <div className="twm-faq-info-wrap">

                                        <div className="section-head left">
                                            <h2 className="twm-large-title site-text-dark">FAQS {cardData.keyword} For Shreesha Tours & Travels </h2>
                                        </div>


                                        <div className="twm-faq-info">
                                            <div className="accordion twm-acdn" id="sf-faq-accordion">

                                                <FaqSection
                                                    title=""
                                                    subtitle=""
                                                    items={faqData}
                                                />

                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>

                            <TestimonialSectionKeyword
                                testimonials={testimonials}
                            />


                            <ContactShowcase keyword={cardData.keyword} />
                        </div>

                        <div className='col-12 col-md-4' >
                            <div className="routeList">
                                {Images.map((e, i) => {
                                    const isExternal = typeof e.link === "string" && /^https?:\/\//i.test(e.link);
                                    const href = isExternal ? e.link : `/${String(e.link || "").replace(/^\/+/, "")}`;

                                    return (
                                        <a
                                            key={e.link || i}
                                            href={href}
                                            className="routeItem"
                                            aria-label={e.text}
                                            {...(isExternal ? { target: "_blank", rel: "noopener noreferrer" } : {})}
                                        >
                                            <div className="routeThumb">
                                                <img src={e.place} alt="" loading="lazy" />
                                            </div>

                                            <div className="routeMeta">
                                                <h6 className="routeTitle">{e.text}</h6>
                                                <span className="routeUnderline" />
                                            </div>

                                            <span className="routeArrow" aria-hidden>›</span>
                                        </a>
                                    );
                                })}
                            </div>




                            <div>
                                <FleetHighway />
                            </div>
                            <div className="pc-contact">
                                <h4 className="pc-title">Contact Information</h4>

                                <div className="pc-grid">
                                    {/* Phones */}
                                    <section className="pc-tile">
                                        <header className="pc-tile-head">
                                            <i className="fas fa-phone-alt"></i>
                                            <span>Phone Numbers</span>
                                        </header>

                                        <div className="pc-list">
                                            <a href="tel:+918355835813 " className="pc-call">+91 8355835813 </a>
                                        </div>
                                        <div className="pc-list">
                                            <a href="tel:+919930929439 " className="pc-call">+91 9930929439 </a>
                                        </div>
                                        <div className="pc-list">
                                            <a href="tel:+919022432779 " className="pc-call">+91 9022432779 </a>
                                        </div>
                                        <div className="pc-cta">
                                            <a
                                                href="https://wa.me/91919930929439 "
                                                target="_blank"
                                                rel="noopener noreferrer"
                                                className="pc-whats"
                                            >
                                                <i className="bi bi-whatsapp"></i> WhatsApp
                                            </a>
                                            <a href="tel:+918355835813 " className="pc-primary">
                                                Call Now
                                            </a>
                                        </div>
                                    </section>

                                    {/* Email */}
                                    <section className="pc-tile">
                                        <header className="pc-tile-head">
                                            <i className="fa-solid fa-envelope"></i>
                                            <span>Email</span>
                                        </header>

                                        <a href="mailto:booking@shreeshatravels.com" className="pc-email">
                                            booking@shreeshatravels.com
                                        </a>
                                    </section>

                                    {/* Address */}
                                    <section className="pc-tile">
                                        <header className="pc-tile-head">
                                            <i className="fa-solid fa-location-dot"></i>
                                            <span>Address</span>
                                        </header>

                                        <address className="pc-address">
                                            <strong>Shreesha Tours & Travels</strong><br />
                                            Office 125, Saishraddha CHS,
                                            Plot No 47, Near Koparkhairane Police Station,
                                            Sector 5, Sector 4,Ghansoli, Navi Mumbai,
                                            Maharashtra, India- 400701




                                        </address>
                                    </section>
                                </div>
                            </div>


                        </div>
                    </div>
                </div>
            </section>


        </div>
    );
}

export default Taxiserviceatmumbaiinternationalairport;